/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Copilot_Enable_BtnInputs */



/**
* | output |
* | --- |
* | "Enable now" |
*
* @param {Partner_Manage_Copilot_Enable_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_enable_btn = /** @type {((inputs?: Partner_Manage_Copilot_Enable_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_Enable_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt aktivieren")
	return /** @type {LocalizedString} */ ("Enable now")
});